import type { Epic } from '../../../../../api/tasks-client/task-client.type';
import { inkLight, secondaryBase } from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';
import { FiltersList } from './filters-list';

type Props = {
  epics: Epic[];
  selectedEpics: Epic[];
  onSelectEpics: (epics: Epic[]) => void;
};

export const FiltersListEpics = ({ epics, selectedEpics, onSelectEpics }: Props) => {
  return (
    <FiltersList
      items={epics}
      selectedItems={selectedEpics}
      onSelectItems={onSelectEpics}
      getItemName={(epic) => epic.name}
      getItemLabel={(epic) => (
        <>
          <Text size="small" color={secondaryBase} style={{ lineHeight: '20px' }}>
            {epic.title}
          </Text>
        </>
      )}
      getItemDescription={(epic) => (
        <Text size="small" style={{ lineHeight: '20px' }}>
          {epic.name}
        </Text>
      )}
      getItemExtraInfo={(epic) => (
        <Text size="small" color={inkLight}>
          {`${epic.subtasks_count} task${epic.subtasks_count === 1 ? '' : 's'}`}
        </Text>
      )}
    />
  );
};
